import { css } from 'styled-components/macro';

const animationButtonBlue = {
  button: css`
    background: #1b6caa;
  `,
  before: css`
    border: 6px solid #85c7ff;
    box-shadow: 0 0 60px #00a1ffa3;
  `,
  after: css`
    border: 6px solid #85c7ff;
  `,
};

const animationButtonYellow = {
  button: css`
    background: linear-gradient(90deg, #e3cb8f, #f5c242);
    box-shadow: 12px 12px 24px #f5c242b0;
  `,
  before: css`
    border: 6px solid #f5c242;
    box-shadow: 0 0 60px #f5c242a3;
  `,
  after: css`
    border: 6px solid #f5c242;
  `,
};

export const STYLE_FRAGMENTS = {
  animationButtonBlue,
  animationButtonYellow,
};
